import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { Link } from "react-router-dom";
import Noor from "../Images/Noor.png";
import aparat from "../Images/cite/aparat.png";

const Footer = () => (
  <footer className="pageFooter">
    <Row className="m-0 pageFooter-FirstRow">
      <Col md={4} style={{ paddingTop: "30px" }}>
        <Row>
          <p>
            «پژوهیار» نرم‌افزار استناددهی و سازماندهی منابع پژوهشی است. این
            نرم‌افزار به پژوهشگران کمک می‌کند تا گردآوری، سازماندهی و مستندسازی
            منابع علمی موردنظر خود را به آسانی انجام دهند.
          </p>
        </Row>
      </Col>

      <Col md={6} style={{ paddingTop: "30px" }}>
        <Row className="FooterNavMenu">
          <div className="Footer-links-col">
            <a href="/versions"> مشخصات نسخه‌ها</a>
            <a href="/faq"> پرسش‌های متداول</a>
          </div>
          <div className="Footer-links-col">
            <a href="/contact"> ارتباط با ما</a>
            <a href="/about-us">درباره پژوهیار</a>
          </div>
          <div className="Footer-links-col">
            <a href="/jobs-opportunities"> همکاری با پژوهیار</a>
            <Link to="/awards"> افتخارات</Link>
          </div>
          <div className="Footer-links-col">
            <Link to="/privacy-policy"> حریم خصوصی</Link>
          </div>
        </Row>
      </Col>
      <Col
        md={2}
        className="align-self-center"
        style={{ textAlignLast: "center" }}>
        <Row>
          <Col className="social-icons justify-content-center">
            <a
              href="https://www.aparat.com/search/%D9%BE%DA%98%D9%88%D9%87%DB%8C%D8%A7%D8%B1"
              target="_blank"
              rel="noopener noreferrer">
              <img
                style={{ width: 27, height: 27 }}
                src={aparat}
                alt="aparat"
                className="aparat-icon"
              />
            </a>

            <a
              href="https://www.linkedin.com/company/pajoohyar"
              style={{ paddingTop: "3px" }}
              target="_blank"
              rel="noopener noreferrer">
              <FaLinkedin
                className="icon-linkdin"
                style={{ width: 22, height: 22 }}
              />
            </a>
            <a
              href="https://instagram.com/pajoohyar"
              style={{ paddingTop: "3px" }}
              target="_blank"
              className="icon-insta"
              rel="noopener noreferrer">
              <FaInstagram style={{ width: 23, height: 23 }} />
            </a>
          </Col>
        </Row>
      </Col>
    </Row>

    <Row className="m-0" style={{ background: "#cacacc" }}>
      <Col md={3}></Col>
      <Col md={6}>
        <Row className="justify-content-center" style={{ height: "45px" }}>
          <a
            href="http://noorsoft.org"
            style={{
              position: "relative",
              background:
                "linear-gradient(to bottom, rgba(243,244,248,1) 0%, #f1ecec 15%, rgb(202,202,204) 37%)",
              bottom: "40px",
              padding: "5px 30px",
            }}>
            <img src={Noor} height="75px" width="82px" alt=""></img>
          </a>
        </Row>
        <Row
          className="justify-content-center"
          style={{ whiteSpace: "break-spaces" }}>
          <p className="text-center">
            حقوق مادی و معنوی اين پايگاه متعلق به{" "}
            <a
              href="http://noorsoft.org"
              style={{ fontWeight: "bold", color: "black" }}
              target="_blank"
              rel="noopener noreferrer">
              مرکز تحقیقات کامپیوتری علوم اسلامی
            </a>{" "}
            است و نشر غیرمجاز محتوای آن پیگرد قانونی دارد.
          </p>
        </Row>
      </Col>
      <Col md={3}></Col>
    </Row>
  </footer>
);

export default Footer;
